import { useFormatUniqueness } from './useFormatUniqueness'
import { Option } from '../interfaces/multiselect'

const usePreSelectedOptions = (selectedOptions: Option[]): Option[] => {
  const uniqueSelectedOptions = useFormatUniqueness(selectedOptions)
  return uniqueSelectedOptions && uniqueSelectedOptions.length > 0 ? uniqueSelectedOptions : []
}

export default usePreSelectedOptions
